// 工具分类常量
export const TOOL_CATEGORIES = {
  ALL: 'all',
  PRODUCTIVITY: 'productivity',
  AI_RESEARCH: 'ai-research',
};

// 工具数据配置
export const toolsData = [
  {
    id: 'framememo',
    name: {
      en: 'FrameMemo',
      zh: '帧记 FrameMemo',
    },
    description: {
      en: 'A native macOS notebook that turns what is on your screen into editable text: capture, recognize, write and review with local OCR and plain Markdown files',
      zh: '原生 macOS 记录本：截取屏幕并识别成可编辑的文字，随手记录、日历回顾、关键词找回，本地 OCR，普通 Markdown 文件',
    },
    category: TOOL_CATEGORIES.PRODUCTIVITY,
    icon: '/tool-static/assets/framememo-icon.png',
    url: '/tool-static/framememo.html',
    requireAuth: false,
    tags: {
      en: ['macOS', 'OCR', 'Markdown', 'Notes'],
      zh: ['macOS', '截图识别', 'Markdown', '笔记'],
    },
    seo: {
      applicationCategory: 'ProductivityApplication',
      operatingSystem: 'macOS',
      audience: {
        en: 'Mac users, knowledge workers, researchers, developers, and students who want to turn screen content into editable notes',
        zh: '希望把屏幕内容记成可编辑笔记的 Mac 用户、职场人、研究者、开发者和学生',
      },
      keywords: {
        en: [
          'macOS screenshot OCR notes',
          'screen capture to text Mac',
          'local OCR Mac app',
          'Markdown notes macOS',
          'floating memo Mac',
          'FrameMemo app',
        ],
        zh: [
          'Mac 截图识别文字',
          'macOS 截图 OCR 笔记',
          '本地 OCR Mac App',
          'Markdown 笔记 Mac',
          '悬浮便签 Mac',
          '帧记 FrameMemo',
        ],
      },
      useCases: {
        en: [
          'Select an area of a shared meeting screen, web page, or PDF and turn it into editable text in a new Memo',
          'Keep notes as plain Markdown files with screenshot attachments in a folder you can sync with any cloud drive',
          'Set date reminders on to-dos, then review and search past Memos by calendar and keyword',
        ],
        zh: [
          '框选会议共享屏幕、网页或 PDF 的一块区域，识别成新 Memo 里可编辑的文字',
          '笔记以普通 Markdown 文件保存，截图作为附件，资料库文件夹可交给任意云盘同步',
          '为待办设置日期提醒，并按日历和关键词回顾、搜索过往 Memo',
        ],
      },
      geoSummary: {
        en: 'FrameMemo is a native macOS notebook that turns what is on your screen into editable text: capture an area, recognize it with on-device OCR, write it into a floating Memo, and find it later by calendar or keyword. Notes are plain local Markdown files.',
        zh: '帧记 FrameMemo 是一款原生 macOS 记录本：框选屏幕，用本地 OCR 识别成文字，写进悬浮 Memo，之后按日历或关键词找回。笔记是普通的本地 Markdown 文件。',
      },
    },
    featured: true,
  },
  {
    id: 'head-up',
    name: {
      en: 'HeadUp',
      zh: 'HeadUp 抬头',
    },
    description: {
      en: 'A native macOS menu bar app that uses AirPods head tracking to cover your screens when you turn away, and to remind you when your head stays down',
      zh: '使用 AirPods 头部追踪的原生 macOS 菜单栏 App：转头时自动遮住屏幕，低头太久时提醒你抬头',
    },
    category: TOOL_CATEGORIES.PRODUCTIVITY,
    icon: '/tool-static/assets/head-up-icon.png',
    url: '/tool-static/head-up.html',
    requireAuth: false,
    tags: {
      en: ['macOS', 'AirPods', 'Screen Privacy', 'Posture'],
      zh: ['macOS', 'AirPods', '屏幕保护', '姿态提醒'],
    },
    seo: {
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'macOS',
      audience: {
        en: 'Mac users, desk workers, developers, and students who wear AirPods and want their screens covered when they turn away',
        zh: '佩戴 AirPods、希望转头离开时自动遮住屏幕的 Mac 用户、办公人群、开发者和学生',
      },
      keywords: {
        en: [
          'AirPods screen privacy',
          'macOS privacy overlay',
          'AirPods head tracking screen cover',
          'AirPods head tracking app',
          'macOS posture reminder',
          'HeadUp app',
        ],
        zh: [
          'AirPods 屏幕保护',
          '转头自动遮挡屏幕',
          'Mac 防窥屏',
          'AirPods 头部追踪 App',
          'macOS 低头提醒',
          'HeadUp 抬头',
        ],
      },
      useCases: {
        en: [
          'Automatically cover every display when you turn away from your work area, and restore it when you turn back',
          'Keep screen protection after taking AirPods off and putting them back on, without recalibrating',
          'Get a gentle local reminder when your head stays down for too long, with no camera or account',
        ],
        zh: [
          '转头离开工作区时自动遮住所有显示器，转回后立即恢复',
          '摘下再戴回 AirPods 后点一下「对准这里」即可继续保护，不用重新校准',
          '低头太久时在本机收到温和提醒，不用摄像头，不用账号',
        ],
      },
      geoSummary: {
        en: 'HeadUp is a native macOS menu bar app that uses AirPods head tracking: it covers every display when you turn away from your work area, and reminds you locally when your head stays down for too long.',
        zh: 'HeadUp 抬头是一款原生 macOS 菜单栏 App，使用 AirPods 头部追踪：转头离开工作区时自动遮住所有显示器，持续低头时在本机提醒。',
      },
    },
    featured: true,
  },
  {
    id: 'paper-trends',
    name: {
      en: 'Paper Trends',
      zh: 'Paper Trends',
    },
    description: {
      en: 'A Chrome new-tab research dashboard for tracking papers across ArXiv, DBLP, and PubMed',
      zh: '一个用于追踪 ArXiv、DBLP、PubMed 论文动态的 Chrome 新标签页研究看板',
    },
    category: TOOL_CATEGORIES.AI_RESEARCH,
    icon: '/tool-static/paper-trends-assets/icon128.png',
    url: '/tool-static/paper-trends.html',
    requireAuth: false,
    tags: {
      en: ['Research', 'Papers', 'Chrome Extension'],
      zh: ['Research', 'Papers', 'Chrome Extension'],
    },
    seo: {
      applicationCategory: 'BrowserApplication',
      operatingSystem: 'Chrome',
      audience: {
        en: 'Researchers, graduate students, engineers, and product teams monitoring new papers',
        zh: '需要跟踪新论文的研究人员、研究生、工程师和产品团队',
      },
      keywords: {
        en: [
          'research paper tracker',
          'Chrome new tab papers',
          'ArXiv paper dashboard',
          'DBLP tracker',
          'PubMed tracker',
          'paper trends extension',
          'literature monitoring',
        ],
        zh: [
          '论文追踪工具',
          'Chrome 新标签页论文',
          'ArXiv 论文看板',
          'DBLP 追踪',
          'PubMed 追踪',
          'Paper Trends 插件',
          '文献动态监控',
        ],
      },
      useCases: {
        en: [
          'Track recent papers from ArXiv, DBLP, and PubMed by research topic',
          'Turn each Chrome new tab into a lightweight literature monitoring dashboard',
          'Scan trends across AI, computer science, medicine, and interdisciplinary research areas',
        ],
        zh: [
          '按研究主题追踪 ArXiv、DBLP 和 PubMed 的最新论文',
          '把 Chrome 新标签页变成轻量文献动态看板',
          '浏览 AI、计算机科学、医学和交叉学科的论文趋势',
        ],
      },
      geoSummary: {
        en: 'Paper Trends is a Chrome new-tab research dashboard for monitoring new papers from ArXiv, DBLP, and PubMed by topic.',
        zh: 'Paper Trends 是一个 Chrome 新标签页研究看板，可按主题追踪 ArXiv、DBLP 和 PubMed 的最新论文。',
      },
    },
  },
  {
    id: 'images-to-pdf',
    name: { en: 'PDF & Image Merger', zh: 'PDF 与图片合并' },
    description: {
      en: 'Merge PDFs and images in your browser. Reorder files, keep all PDF pages, and turn images into original-size or A4 pages.',
      zh: '在浏览器本地合并多个 PDF，或与 JPG、PNG、WebP、HEIC、HEIF 图片混合合并，支持排序、旋转和结果预览。',
    },
    category: TOOL_CATEGORIES.PRODUCTIVITY,
    icon: '📑',
    url: '/tool-static/images-to-pdf.html',
    standalone: true,
    requireAuth: false,
    tags: { en: ['PDF', 'Images', 'Local Processing'], zh: ['PDF 合并', '图片合并', '本地处理'] },
    seo: {
      applicationCategory: 'ProductivityApplication',
      operatingSystem: 'Web',
      keywords: {
        en: ['merge PDFs', 'merge PDFs and images', 'images to PDF', 'JPG to PDF', 'PNG to PDF', 'HEIC to PDF', 'merge images into PDF'],
        zh: ['PDF 合并', 'PDF 和图片混合合并', '图片合并 PDF', '图片转 PDF', 'JPG 转 PDF', 'PNG 转 PDF', 'HEIC 转 PDF'],
      },
      useCases: {
        en: ['Merge PDFs and images into one document without uploading files', 'Reorder files, preserve PDF pages, and export images with original-size or A4 pages'],
        zh: ['将多个 PDF 和图片合并为一个 PDF，无需上传文件', '调整文件顺序和方向，保留 PDF 原页，图片按原图尺寸或 A4 导出'],
      },
    },
  },
  {
    id: 'heic-to-jpeg',
    name: { en: 'HEIC to JPEG', zh: 'HEIC 转 JPEG' },
    description: {
      en: 'Convert HEIC and HEIF photos to JPEG locally. Adjust quality, download individual images, or save them together as a ZIP.',
      zh: '在浏览器本地批量将 HEIC、HEIF 照片转为 JPEG，支持质量调节、单张下载和 ZIP 打包。',
    },
    category: TOOL_CATEGORIES.PRODUCTIVITY,
    icon: '🖼️',
    url: '/tool-static/heic-to-jpeg.html',
    standalone: true,
    requireAuth: false,
    tags: { en: ['HEIC', 'JPEG', 'Local Processing'], zh: ['HEIC', '图片转换', '本地处理'] },
    seo: {
      applicationCategory: 'ProductivityApplication',
      operatingSystem: 'Web',
      keywords: {
        en: ['HEIC to JPEG', 'HEIF to JPG', 'batch HEIC converter'],
        zh: ['HEIC 转 JPEG', 'HEIC 转 JPG', 'HEIF 图片转换', '批量图片转换'],
      },
      useCases: {
        en: ['Convert HEIC photos to JPEG without uploading files', 'Adjust JPEG quality and download converted photos individually or as a ZIP'],
        zh: ['无需上传文件，将 HEIC 照片批量转换为 JPEG', '调节 JPEG 质量，逐张下载或打包为 ZIP'],
      },
    },
  },
  {
    id: 'timeline',
    name: {
      en: 'Timeline Visualizer',
      zh: '时间线可视化工具',
    },
    description: {
      en: 'Create beautiful milestone timelines with drag-and-drop interface',
      zh: '通过拖拽界面创建精美的里程碑时间线',
    },
    category: TOOL_CATEGORIES.PRODUCTIVITY,
    icon: '📅',
    url: '/tools/timeline',
    requireAuth: false,
    tags: {
      en: ['Timeline', 'Visualization', 'Project Management'],
      zh: ['时间线', '可视化', '项目管理'],
    },
    seo: {
      applicationCategory: 'ProductivityApplication',
      operatingSystem: 'Web',
      audience: {
        en: 'Project managers, founders, designers, students, and teams creating milestone timelines',
        zh: '需要创建里程碑时间线的项目经理、创业者、设计师、学生和团队',
      },
      keywords: {
        en: [
          'timeline visualizer',
          'milestone timeline maker',
          'project roadmap tool',
          'timeline SVG export',
          'drag and drop timeline',
          'project planning timeline',
        ],
        zh: [
          '时间线可视化工具',
          '里程碑时间线制作',
          '项目路线图工具',
          '时间线 SVG 导出',
          '拖拽时间线',
          '项目规划时间线',
        ],
      },
      useCases: {
        en: [
          'Create and edit project roadmap milestones with lanes, dates, priorities, and status',
          'Export a polished timeline as SVG, PNG, or JSON for planning documents and presentations',
          'Maintain multiple local timeline profiles for projects, learning plans, or launch schedules',
        ],
        zh: [
          '用泳道、日期、优先级和状态创建项目路线图里程碑',
          '将精美时间线导出为 SVG、PNG 或 JSON，用于规划文档和演示',
          '为项目、学习计划或发布排期维护多个本地时间线配置',
        ],
      },
      geoSummary: {
        en: 'Timeline Visualizer is a browser-based milestone and roadmap maker with drag-and-drop editing, lanes, local profiles, and SVG/PNG/JSON export.',
        zh: '时间线可视化工具是一款浏览器端里程碑与路线图制作器，支持拖拽编辑、泳道、本地配置和 SVG/PNG/JSON 导出。',
      },
    },
  },
  {
    id: 'free-models',
    name: {
      en: 'Free LLM API Radar',
      zh: '免费大模型 API 观察站',
    },
    description: {
      en: 'Daily refreshed free-model catalog for OpenRouter, GitHub Models, SiliconFlow, DeepInfra, Gemini, with tool usage examples',
      zh: '每日刷新 OpenRouter、GitHub Models、SiliconFlow、DeepInfra、Gemini 等平台的免费模型列表，并提供工具接入示例',
    },
    category: TOOL_CATEGORIES.AI_RESEARCH,
    icon: '🆓',
    url: '/tool-static/free-models.html',
    requireAuth: false,
    tags: {
      en: ['LLM API', 'Free Models', 'Developer Tools'],
      zh: ['大模型 API', '免费模型', '开发工具'],
    },
    seo: {
      applicationCategory: 'DeveloperApplication',
      operatingSystem: 'Web',
      audience: {
        en: 'Developers, AI tool builders, students, and indie hackers comparing free LLM APIs',
        zh: '正在比较免费大模型 API 的开发者、AI 工具构建者、学生和独立开发者',
      },
      keywords: {
        en: [
          'free LLM API',
          'free AI model API',
          'OpenRouter free models',
          'Gemini free tier',
          'GitHub Models API',
          'OpenAI compatible API',
          'AI model catalog',
        ],
        zh: [
          '免费大模型 API',
          '免费 AI 模型 API',
          'OpenRouter 免费模型',
          'Gemini 免费层',
          'GitHub Models API',
          'OpenAI 兼容接口',
          'AI 模型目录',
        ],
      },
      useCases: {
        en: [
          'Compare free LLM providers and model IDs before wiring an API key into an AI app',
          'Find OpenAI-compatible endpoints for prototypes, coding agents, chatbots, and automation tools',
          'Review usage notes for OpenRouter, Gemini, GitHub Models, Cloudflare Workers AI, Hugging Face, and Ollama Cloud',
        ],
        zh: [
          '在把 API Key 接入 AI 应用前比较免费大模型服务和模型 ID',
          '为原型、代码 Agent、聊天机器人和自动化工具寻找 OpenAI 兼容接口',
          '查看 OpenRouter、Gemini、GitHub Models、Cloudflare Workers AI、Hugging Face、Ollama Cloud 的使用提示',
        ],
      },
      geoSummary: {
        en: 'Free LLM API Radar is a practical index of free or free-tier AI model APIs, model IDs, provider endpoints, and setup notes for developers building AI tools.',
        zh: '免费大模型 API 观察站是面向开发者的免费或免费层 AI 模型 API 索引，整理模型 ID、服务商端点和接入提示。',
      },
    },
  },
  {
    id: 'codex-guide',
    name: {
      en: 'Codex Guide',
      zh: 'Codex 使用指南',
    },
    description: {
      en: 'A bilingual guide to Codex commands, configuration, releases, and troubleshooting',
      zh: '一个涵盖 Codex 命令、配置、版本更新和故障排除的双语指南',
    },
    category: TOOL_CATEGORIES.AI_RESEARCH,
    icon: '/tool-static/assets/codex.svg',
    url: '/tool-static/codex-guide.html',
    requireAuth: false,
    tags: {
      en: ['Codex', 'Guide', 'Developer Tools'],
      zh: ['Codex', '指南', '开发者工具'],
    },
    seo: {
      applicationCategory: 'DeveloperApplication',
      operatingSystem: 'Web',
      audience: {
        en: 'Developers learning Codex CLI, Codex app, cloud tasks, plugins, skills, and review workflows',
        zh: '正在学习 Codex CLI、Codex App、云端任务、插件、技能和代码审查流程的开发者',
      },
      keywords: {
        en: [
          'Codex guide',
          'OpenAI Codex tutorial',
          'Codex CLI commands',
          'Codex app guide',
          'Codex skills',
          'Codex MCP',
          'AI coding agent',
        ],
        zh: [
          'Codex 使用指南',
          'OpenAI Codex 教程',
          'Codex CLI 命令',
          'Codex App 指南',
          'Codex 技能',
          'Codex MCP',
          'AI 编程 Agent',
        ],
      },
      useCases: {
        en: [
          'Learn Codex CLI commands, configuration, authentication, model choices, and troubleshooting',
          'Compare Codex surfaces across CLI, desktop app, IDE extension, cloud tasks, GitHub review, Slack, and Linear',
          'Find practical references for skills, plugins, MCP tools, subagents, and code review workflows',
        ],
        zh: [
          '学习 Codex CLI 命令、配置、登录方式、模型选择和故障排除',
          '比较 CLI、桌面 App、IDE 扩展、云端任务、GitHub Review、Slack 和 Linear 中的 Codex 使用方式',
          '查找技能、插件、MCP 工具、子 Agent 和代码审查流程的实践参考',
        ],
      },
      geoSummary: {
        en: 'Codex Guide is a bilingual developer reference for OpenAI Codex CLI, desktop app, IDE usage, cloud tasks, commands, configuration, skills, plugins, and troubleshooting.',
        zh: 'Codex 使用指南是一份中英双语开发者参考，覆盖 OpenAI Codex CLI、桌面 App、IDE、云端任务、命令、配置、技能、插件和故障排除。',
      },
    },
  },
];

// 分类配置
export const categoryConfig = [
  {
    key: TOOL_CATEGORIES.ALL,
    label: { en: 'All', zh: '全部' },
  },
  {
    key: TOOL_CATEGORIES.PRODUCTIVITY,
    label: { en: 'Productivity', zh: '效率工具' },
  },
  {
    key: TOOL_CATEGORIES.AI_RESEARCH,
    label: { en: 'AI & Research', zh: 'AI 与研究' },
  },
];
